'use strict';

import animations from 'tc-neos-animations';

const init = () => {
    const toTop = document.querySelector('.scroll-to-top');

    if (toTop) {
        toTop.addEventListener('click', () => {
            animations.scrollToTop();
        });
    }
}

export default {init};
